import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77b5186b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_ctx.allowed)
    ? (_openBlock(), _createBlock(_component_a_tooltip, {
        key: 0,
        title: '在线排料 · '+(_ctx.snapshot.loaded?'待处理失败 '+_ctx.failedCount+' 个':'正在读取任务')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_badge, {
            count: _ctx.failedCount,
            "overflow-count": 99,
            offset: [-2,3]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "text",
                class: "nesting-task-indicator",
                "aria-label": "在线排料失败任务",
                onClick: _ctx.open
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _ctx.icon,
                    alt: "在线排料"
                  }, null, 8, _hoisted_1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["count"])
        ]),
        _: 1
      }, 8, ["title"]))
    : _createCommentVNode("", true)
}